import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { handlemonthlyLoadingGraphList } from "../../../Api/api";

const initialState = {
   tripDetails: null,
   monthWise: null,
   loading: false,
   error: null,
};

/* ---------- Line Graph ---------- */
export const monthlyLoadingGraphMasterAsync = createAsyncThunk(
   "reportMaster/monthlyGraphDetails",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await handlemonthlyLoadingGraphList(data);

         if (response.statusCode === 200) {
            done?.(response.res);
            return response.res;
         }

         throw response;
      } catch (error) {
         err?.(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

/* ---------- Bar Graph ---------- */
export const monthlyLoadingGraphBarMasterAsync = createAsyncThunk(
   "reportMaster/monthlyGraphCounts",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await handlemonthlyLoadingGraphList(data);

         if (response.statusCode === 200) {
            done?.(response.res);
            return response.res.month_wise;
         }

         throw response;
      } catch (error) {
         err?.(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

/* ---------- Slice ---------- */
const monthlyLoadingGraphSlice = createSlice({
   name: "reportMaster/monthlyLoadingGraph",
   initialState,
   reducers: {},
   extraReducers: (builder) => {
      builder
         /* Line Graph */
         .addCase(monthlyLoadingGraphMasterAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(monthlyLoadingGraphMasterAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.tripDetails = action.payload;
         })
         .addCase(monthlyLoadingGraphMasterAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
         })

         /* Bar Graph */
         .addCase(monthlyLoadingGraphBarMasterAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(monthlyLoadingGraphBarMasterAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.monthWise = action.payload;
         })
         .addCase(monthlyLoadingGraphBarMasterAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
         });
   },
});

export default monthlyLoadingGraphSlice.reducer;
